import { WrenchIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const Wrench = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <WrenchIcon size={Sizes[size]} {...rest} color={fill} />;
};

Wrench.displayName = 'Wrench';
